import { ChangeDetectorRef, Component, HostListener, Injectable, LOCALE_ID, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CalendarDateFormatter, CalendarEvent, CalendarView, DateFormatterParams } from 'angular-calendar';
import { AgendaProService } from './agendapro.service';
import { AppointmentModel } from './appointment.model';
import { AddAppointmentDialogComponent } from './add-appointment-dialog.component';
import { AppointmentDetailsDialogComponent } from './appointment-details-dialog.component';
import { DummyComponent } from '../../shared/dummy.component';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { TicketModel } from '../invoice/tickets/ticket.model';
import { EmployeesListService } from '../employees/employees-list.service';
import { ConceptModel } from '../concept/concept/concept.model';
import { ConceptService } from '../concept/concept/concept.service';
import { ContactModel } from '../contact/contact/contact.model';
import { ContactService } from '../contact/contact/contact.service';
import { addDays, addMonths, endOfWeek, format, startOfWeek } from 'date-fns';
import { formatDate } from '@angular/common';
import { es } from 'date-fns/locale';
import { AppointmentService } from './appointment.service';
import { CustomDateFormatter } from '../../shared/customs/custom-date-formatter';

@Component({
    selector: 'app-agendapro',
    templateUrl: './agendapro.component.html',
    styleUrls: ['./agendapro.component.css'],
    providers: [
        { provide: LOCALE_ID, useValue: 'es' }, // 👈 idioma español
        { provide: CalendarDateFormatter, useClass: CustomDateFormatter } // 👈 solo este componente
    ],
    standalone: false
})
export class AgendaProComponent implements OnInit {

  CalendarView = CalendarView;
  view: CalendarView = CalendarView.Week;
  viewDate: Date = new Date();

  selectedMonth = this.viewDate.getMonth();
  selectedYear = this.viewDate.getFullYear();

  months = [
    'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
    'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
  ];

  years = Array.from({ length: 10 }, (_, i) => this.selectedYear - 5 + i); // ej. 2020–2029

  events: CalendarEvent[] = [
  ];

  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent): void {
    const overlay = document.querySelector('.side-dialog-panel .mat-mdc-dialog-container');
    if (overlay && !overlay.contains(event.target as Node)) {
      this.dialog.closeAll();
    }
  }

  eventsDtos = [];

  get viewTitle(): string {
    if (this.view === CalendarView.Month) {
      return format(this.viewDate, "MMMM yyyy", { locale: es });
    }
    if (this.view === CalendarView.Week) {
      const start = startOfWeek(this.viewDate, { weekStartsOn: 1 });
      const end = endOfWeek(this.viewDate, { weekStartsOn: 1 });
      return `Semana del ${format(start, "d 'al' ", { locale: es })}${format(end, "d 'de' MMMM yyyy", { locale: es })}`;
    }
    if (this.view === CalendarView.Day) {
      return format(this.viewDate, "EEEE d 'de' MMMM yyyy", { locale: es });
    }
    return '';
  }

  previous(): void {
    if (this.view === CalendarView.Month) {
      this.viewDate = addMonths(this.viewDate, -1);
    } else {
      this.viewDate = addDays(this.viewDate, this.view === CalendarView.Week ? -7 : -1);
    }
    this.syncSelectors();
  }

  next(): void {
    if (this.view === CalendarView.Month) {
      this.viewDate = addMonths(this.viewDate, 1);
    } else {
      this.viewDate = addDays(this.viewDate, this.view === CalendarView.Week ? 7 : 1);
    }
    this.syncSelectors();
  }

  today(): void {
    this.viewDate = new Date();
    this.syncSelectors();
  }

  changeMonth(): void {
    const newDate = new Date(this.viewDate);
    newDate.setMonth(this.selectedMonth);
    this.viewDate = newDate;
  }

  changeYear(): void {
    const newDate = new Date(this.viewDate);
    newDate.setFullYear(this.selectedYear);
    this.viewDate = newDate;
  }

  private syncSelectors(): void {
    this.selectedMonth = this.viewDate.getMonth();
    this.selectedYear = this.viewDate.getFullYear();
  }

  onEventClicked({ event }: { event: CalendarEvent }): void {
    const dialogRef = this.dialog.open(AppointmentDetailsDialogComponent, {
      width: '400px',
      height: '100vh',
      position: { right: '0', top: '0' },
      hasBackdrop: false, // 🔹 No bloquea la pantalla
      panelClass: 'side-dialog-panel', // 🔹 Clase personalizada
      data: {
        appointment: event.meta,
        contacts: this.contacts,
        concepts: this.concepts,
        employees: this.employees
      }
    });

    dialogRef.afterClosed().subscribe(() => this.loadAppointments());
  }

  onHourClicked({ date }: { date: Date }): void {
    this.dialog.open(AddAppointmentDialogComponent, {
      width: '600px',
      maxWidth: '96vw',
      maxHeight: '90vh',
      data: { mode: 'panel' }
    });

    //  const dialogRef = this.dialog.open(AppointmentDetailsDialogComponent, {
    //   width: '400px',
    //   height: '100vh',
    //   position: { right: '0', top: '0' },
    //   hasBackdrop: false, // 🔹 No bloquea la pantalla
    //   panelClass: 'side-dialog-panel', // 🔹 Clase personalizada
    //   data: {
    //     // appointment: event.meta,
    //     contacts: this.contacts,
    //     concepts: this.concepts,
    //     employees: this.employees
    //   }
    // });

    // dialogRef.afterClosed().subscribe(() => this.loadAppointments());

    // console.log('🕐 Clic en una hora vacía:', date);

    // const start = new Date(date);
    // const end = new Date(start.getTime() + 60 * 60 * 1000);

    // this.prepareNewEvent(start, end);
    // this.createEvent();
  }

  onDayClicked({ date }: { date: Date }): void {

    // Si haces clic en el mes, podemos iniciar el evento en esa fecha a las 09:00 por ejemplo
    const start = new Date(date);
    start.setHours(9, 0, 0);
    const end = new Date(start.getTime() + 60 * 60 * 1000);

    this.prepareNewEvent(start, end);
    // this.createEvent();
  }

  /** 🔧 Método común para formatear y preparar la estructura */
  private prepareNewEvent(start: Date, end: Date): void {
    // const formatDateTime = (d: Date) => {
    //   const year = d.getFullYear();
    //   const month = ('0' + (d.getMonth() + 1)).slice(-2);
    //   const day = ('0' + d.getDate()).slice(-2);
    //   const hours = ('0' + d.getHours()).slice(-2);
    //   const minutes = ('0' + d.getMinutes()).slice(-2);
    //   return `${year}-${month}-${day}T${hours}:${minutes}`;
    // };

    // this.newEvent.startDate = formatDateTime(start);
    // this.newEvent.endDate = formatDateTime(end);
  }







  appointments: CalendarEvent[] = [];
  blockedDays: string[] = []; // Festivos en formato YYYY-MM-DD

  employees: any[] = [];
  draggedService: any = null;
  refresh: Subject<any> = new Subject();
  ticket: TicketModel = new TicketModel();

  defaultDurationMinutes = 30;

  constructor(
    private appointmentServiceV2: AppointmentService,
    private appointmentService: AgendaProService,
    private dialog: MatDialog,
    private cdr: ChangeDetectorRef,
    private dummy: DummyComponent,
    private router: Router,
    private contactService: ContactService,
    private conceptService: ConceptService,
    private employeeService: EmployeesListService,
  ) { }

  contacts: ContactModel[] = [];
  concepts: ConceptModel[] = [];
  working = true;

  ngOnInit() {
    const year = new Date().getFullYear();
    this.blockedDays = this.getSpanishHolidays(year);

    this.contactService.getList().then(response => {
      this.contacts = response.list;
    });

    this.conceptService.getList().then(response => {
      this.concepts = response;

    });

    this.employeeService.getList().then(response => {
      this.employees = response;
    });

    // this.loadAppointments();

    this.appointmentServiceV2.getBySearch({}).subscribe(resp => {
    });
  }

  loadAppointments() {
    this.appointmentService.getAppointments().then(res => {
      if (!res || !Array.isArray(res)) {
        console.warn('No se recibieron citas válidas:', res);
        return;
      }

      const mappedAppointments = res.map((a: AppointmentModel) => {
        const start = new Date(a.startTime);
        const end = new Date(a.endTime);

        let employeeName = 'N/D';
        if (a.employeeId && this.employees.length > 0) {
          const emp = this.employees.find(e => e.uid === a.employeeId);
          if (emp) employeeName = emp.name;
        }

        let conceptName = 'Servicio';
        if (a.conceptUid && this.concepts.length > 0) {
          const concept = this.concepts.find(c => c.uid === a.conceptUid);
          if (concept) conceptName = concept.name;
        }

        let title = `${conceptName} - Empleado: ${employeeName} - ${start.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' })} - ${end.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' })}`;
        if (a.ticket) title += ` - Ticket creado: ${a.ticketNumber}`;

        return {
          start,
          end,
          title,
          color: { primary: '#e3fd64', secondary: '#f7c111' },
          cssClass: 'custom-event-text',
          meta: a
        };
      });

      this.appointments = mappedAppointments;
      this.refresh.next(void 0);
      this.cdr.detectChanges();
    }).catch(err => console.error('Error al cargar citas:', err));
  }

  setView(view: CalendarView) { this.view = view; } prevDay() { const newDate = new Date(this.viewDate); newDate.setDate(this.viewDate.getDate() - 1); this.viewDate = newDate; } nextDay() { const newDate = new Date(this.viewDate); newDate.setDate(this.viewDate.getDate() + 1); this.viewDate = newDate; }

  // === FESTIVOS ===

  dayModifier(day: any): void {
    const dateStr = this.formatDate(day.date);
    if (this.blockedDays.includes(dateStr)) {
      day.cssClass = 'holiday-day';
      day.badgeTotal = 0;
      day.tooltip = 'Festivo';
    }
  }

  private formatDate(date: Date): string {
    const pad = (n: number) => n.toString().padStart(2, '0');
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
  }

  private getSpanishHolidays(year: number): string[] {
    const holidays: string[] = [];
    const pad = (n: number) => n.toString().padStart(2, '0');
    const format = (d: Date) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

    // Festivos fijos
    holidays.push(format(new Date(year, 0, 1)));   // Año Nuevo
    holidays.push(format(new Date(year, 0, 6)));   // Reyes
    holidays.push(format(new Date(year, 4, 1)));   // Día del Trabajo
    holidays.push(format(new Date(year, 7, 15)));  // Asunción
    holidays.push(format(new Date(year, 9, 12)));  // Fiesta Nacional
    holidays.push(format(new Date(year, 10, 1)));  // Todos los Santos
    holidays.push(format(new Date(year, 11, 6)));  // Constitución
    holidays.push(format(new Date(year, 11, 8)));  // Inmaculada
    holidays.push(format(new Date(year, 11, 25))); // Navidad

    // Semana Santa
    const easter = this.calculateEasterSunday(year);
    const goodFriday = new Date(easter); goodFriday.setDate(easter.getDate() - 2);
    const easterMonday = new Date(easter); easterMonday.setDate(easter.getDate() + 1);
    holidays.push(format(goodFriday));
    holidays.push(format(easterMonday));

    return holidays;
  }

  private calculateEasterSunday(year: number): Date {
    const f = Math.floor,
      G = year % 19,
      C = f(year / 100),
      H = (C - f(C / 4) - f((8 * C + 13) / 25) + 19 * G + 15) % 30,
      I = H - f(H / 28) * (1 - f(29 / (H + 1)) * f((21 - G) / 11)),
      J = (year + f(year / 4) + I + 2 - C + f(C / 4)) % 7,
      L = I - J,
      month = 3 + f((L + 40) / 44),
      day = L + 28 - 31 * f(month / 4);
    return new Date(year, month - 1, day);
  }

  // === EVENTOS ===

  openAppointmentDialog(startDate?: Date) {
    const start = startDate || new Date();
    const end = new Date(start.getTime() + this.defaultDurationMinutes * 60000);

    const newAppointment: AppointmentModel = {
      id: 0, conceptUid: '', contactUid: '', employeeId: '', employeeName: '',
      ticket: false, ticketNumber: '', ticketUid: '', startTime: start, endTime: end,
      createdAt: '', updatedAt: '', notes: '', isAllDay: false
    };

    const dialogRef = this.dialog.open(AddAppointmentDialogComponent, {
      data: { newEvent: newAppointment, concepts: this.concepts, contacts: this.contacts, employees: this.employees }
    });

    dialogRef.afterClosed().subscribe(() => this.loadAppointments());
  }

  nuevoServicio() { this.openAppointmentDialog(); }

  onEventClick(event: any) {
    const dialogRef = this.dialog.open(AppointmentDetailsDialogComponent, {
      width: '400px',
      data: { appointment: event.meta, contacts: this.contacts, concepts: this.concepts, employees: this.employees }
    });
    dialogRef.afterClosed().subscribe(() => this.loadAppointments());
  }

  onTimeSlotClick(event: any) {
    // const clickedDate = new Date(event.date);
    // const endDate = new Date(clickedDate.getTime() + 30 * 60 * 1000);
    // const newAppointment: AppointmentModel = {
    //   id: 0, conceptUid: '', contactUid: '', employeeId: '', employeeName: '',
    //   ticket: false, ticketNumber: '', ticketUid: '', startTime: clickedDate, endTime: endDate,
    //   createdAt: '', updatedAt: '', notes: '', isAllDay: false
    // };

    // const dialogRef = this.dialog.open(AddAppointmentDialogComponent, {
    //   data: { date: clickedDate, newEvent: newAppointment, concepts: this.concepts, contacts: this.contacts }
    // });
    // dialogRef.afterClosed().subscribe(() => this.loadAppointments());
  }
  public trackByIndex(i: number) { return i; }

}
